const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-300">
      {children}
    </div>
  );
};

export default Layout;
